/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

export const SET_COLUMNS = 'queryTool/SET_COLUMNS';
export const SET_GROUPING_METHODS = 'queryTool/SET_GROUPING_METHODS';
export const SET_FILTER_METHODS = 'queryTool/SET_FILTER_METHODS';
export const SET_NEW_COLUMNS = 'queryTool/SET_NEW_COLUMNS';
export const SET_ALL_COLUMNS = 'queryTool/SET_ALL_COLUMNS';
export const SET_EDIT_COLUMN = 'queryTool/SET_EDIT_COLUMN';
export const SET_USE_GROUP_BY = 'queryTool/SET_USE_GROUP_BY';
export const SET_USE_LOCAL_TIME = 'queryTool/SET_USE_LOCAL_TIME';
export const SET_SPECIES_LIST_ID = 'queryTool/SET_SPECIES_LIST_ID';
export const SET_LOCAL_TIMEZONE = 'queryTool/SET_LOCAL_TIMEZONE';
export const SET_SORTED = 'queryTool/SET_SORTED';
export const SET_CHECKED = 'queryTool/SET_CHECKED';
export const SET_EXPANDED = 'queryTool/SET_EXPANDED';
export const SET_DATA = 'queryTool/SET_DATA';
export const SET_COUNT = 'queryTool/SET_COUNT';
export const SET_PAGE = 'queryTool/SET_PAGE';
export const SET_PAGE_SIZE = 'queryTool/SET_PAGE_SIZE';
export const SET_INSERT_COLUMN_ID = 'queryTool/SET_INSERT_COLUMN_ID';
export const SET_IS_STALE = 'queryTool/SET_IS_STALE';
export const SET_SHOW_ADD = 'queryTool/SET_SHOW_ADD';
export const SET_FILTER = 'queryTool/SET_FILTER';
export const FINISH_SET_FILTER = 'queryTool/FINISH_SET_FILTER';
export const RESET_NEW_COLUMNS = 'queryTool/RESET_NEW_COLUMNS';
export const CLEAR_QUERY = 'queryTool/CLEAR_QUERY';
export const CHANGE_FAVORITE = 'queryTool/CHANGE_FAVORITE';
export const FINISH_CHANGING_FAVORITES = 'queryTool/FINISH_CHANGING_FAVORITES';
export const INSERT_COLUMNS = 'queryTool/INSERT_COLUMNS';
export const FINISH_INSERT_COLUMNS = 'queryTool/FINISH_INSERT_COLUMNS';
export const DELETE_COLUMNS = 'queryTool/DELETE_COLUMNS';
export const FINISH_DELETE_COLUMNS = 'queryTool/FINISH_DELETE_COLUMNS';
export const RESET_FILTERS = 'queryTool/RESET_FILTERS';
export const FINISH_RESET_FILTERS = 'queryTool/FINISH_RESET_FILTERS';
